module.exports = __webpack_public_path__ + "img/1673511017172-Screenshot_2023-01-09-14-07-40-986_com.here.app.maps.jpg.b2774b7c.webp";